export default function TransitionBlock() {
  return (
    <section className="relative py-24 overflow-hidden bg-gradient-to-br from-teal-500 via-teal-600 to-emerald-600">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Side - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <img
                src="https://public.readdy.ai/ai/img_res/c0711a8ff6e7354a0dc8830b04a14e21.jpg"
                alt="Technologie WhatsApp"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            </div>
            
            {/* Floating Stats */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-2xl p-6 transform hover:scale-110 transition-transform duration-300">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 bg-teal-500 rounded-full flex items-center justify-center">
                  <i className="ri-notification-3-fill text-2xl text-white"></i>
                </div>
                <div>
                  <div className="text-3xl font-bold text-gray-900">100%</div>
                  <div className="text-sm text-gray-600">Instantané</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="text-white">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
              <i className="ri-flashlight-fill text-yellow-300"></i>
              <span className="text-sm font-medium">Technologie Avancée</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
              Restez Connecté en Temps Réel
            </h2>
            
            <p className="text-xl text-teal-50 mb-8 leading-relaxed">
              Ne manquez plus jamais une opportunité. Recevez chaque lead directement sur votre WhatsApp et réagissez instantanément pour maximiser vos conversions.
            </p>

            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-time-line text-2xl text-white"></i>
                </div>
                <div className="text-2xl font-bold mb-2">Instantané</div>
                <div className="text-sm text-teal-50">Notification en &lt;5 secondes</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <div className="text-2xl font-bold mb-2">Sécurisé</div>
                <div className="text-sm text-teal-50">Données cryptées</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-smartphone-line text-2xl text-white"></i>
                </div>
                <div className="text-2xl font-bold mb-2">Mobile</div>
                <div className="text-sm text-teal-50">Accessible partout</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-check-double-line text-2xl text-white"></i>
                </div>
                <div className="text-2xl font-bold mb-2">Fiable</div>
                <div className="text-sm text-teal-50">99.9% de disponibilité</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-10 right-10 w-32 h-32 bg-white/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 left-10 w-40 h-40 bg-emerald-400/20 rounded-full blur-3xl"></div>
    </section>
  );
}